module.exports = __webpack_public_path__ + "static/img/glove_gris_perle.e4ea137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_gris_perle.png
// module id = e9LS
// module chunks = 0